import { useMemo } from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { QueryFnResponse as PoapResponse } from 'api/queries/getPoapViewById.query';

import { HeaderLabel } from 'components/common/bryntumScheduler/types';

const LABEL_ID = 'current-version-label';
const LABEL_CLASS = 'custom-header-label';

interface Props {
    data: PoapResponse | undefined;
}

const isAllContractsAreEqual = (viewRows: PoapResponse['viewRows']): boolean => {
    const numberOfRows = viewRows.length;
    if (numberOfRows === 0) return false;
    if (numberOfRows === 1) return true;
    const firstContractId = viewRows[0].contractId;
    for (let i = 1; i < viewRows.length; i++) {
        if (viewRows[i].contractId !== firstContractId) return false;
    }
    return true;
};

export const SchedulerViewWrapperLogic = ({ data }: Props) => {
    const headerLabels: HeaderLabel[] | null = useMemo(() => {
        if (!data) return null;
        const isAllContractEqual = isAllContractsAreEqual(data?.viewRows ?? []);
        let labelDate: number;
        let formatedDate: string;
        let labelString: string;
        if (isAllContractEqual) {
            // return  current version date label
            labelDate = data.viewRows[0].currentVersionDate;
            formatedDate = moment(labelDate).format(constants.formats.date.default);
            labelString = `Data Date: ${formatedDate}`;
        } else {
            // return today label
            formatedDate = moment().format(constants.formats.date.default);
            labelString = `Today: ${formatedDate}`;
        }
        return [
            {
                id: LABEL_ID,
                name: labelString,
                cls: LABEL_CLASS,
                startDate: new Date(formatedDate),
            },
        ] as HeaderLabel[];
    }, [data]);

    return {
        logic: {
            headerLabels,
        },
    };
};
